namespace RedBullMOBILE360.CVM {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CVM.SegmentCriteriaDialog')
    export class SegmentCriteriaDialog extends Serenity.EntityDialog<SegmentCriteriaRow, any> {
        protected getFormKey() { return SegmentCriteriaForm.formKey; }
        protected getIdProperty() { return SegmentCriteriaRow.idProperty; }
        protected getLocalTextPrefix() { return SegmentCriteriaRow.localTextPrefix; }
        protected getService() { return SegmentCriteriaService.baseUrl; }
        protected getDeletePermission() { return SegmentCriteriaRow.deletePermission; }
        protected getInsertPermission() { return SegmentCriteriaRow.insertPermission; }
        protected getUpdatePermission() { return SegmentCriteriaRow.updatePermission; }

        protected form = new SegmentCriteriaForm(this.idPrefix);
    }
}